import React, { useEffect, useRef } from "react";
import { PromoRibbon, ProductImage, ProductDetails } from "./ProductList"
import { getProductSlug } from "./HelperFunctions";

export const SimilarProducts = () => {
    const sliderPage = useRef(0);
    const productsPerPage = window.innerWidth < 768 ? 3 : window.innerWidth < 992 ? 4 : 5;
    useEffect(() => {
        $("#similar-products .carousel-control-prev").hide();
        const imageHeight = $("#similar-products .item-image").outerHeight();
        const buttonHeight = $("#similar-products .carousel-control-prev").outerHeight();
        $("#similar-products .carousel-control-prev").css("top", imageHeight / 2 - buttonHeight / 2);
        $("#similar-products .carousel-control-next").css("top", imageHeight / 2 - buttonHeight / 2);

        $(".product").css("maxWidth", ($("#similar-products").width() - (14 * (productsPerPage - 1))) / productsPerPage);
    }, []);
    const carouselItems = [];
    for (var i = 0; i < productModel.SimilarItemsList.length; i += productsPerPage) {
        const items = [];
        for (var j = i; j < i + productsPerPage && j < productModel.SimilarItemsList.length; j++) {
            const currItem = productModel.SimilarItemsList[j];
            items.push(
                <div key={`similar-item-${j}`} className="product d-flex flex-column tw-m-0 tw-shadow-none hover:tw-shadow-none tw-grow tw-min-w-[147px] sm:tw-min-w-0">
                    <PromoRibbon item={currItem} />
                    <ProductImage item={currItem} productSlug={getProductSlug(currItem.Heading)} />
                    <ProductDetails item={currItem} productSlug={getProductSlug(currItem.Heading)} isSimilarItem={true} />
                </div>
            );
        }
        carouselItems.push(
            window.innerWidth >= 576
                ? <div key={`carousel-image-${i}`} className={"carousel-item " + (i === 0 ? "active" : "")} >
                    <div className="tw-flex tw-gap-[14px]">{items}</div>
                </div >
                : items
        );
    }

    return (
        !!productModel.SimilarItemsList.length &&
        <div className="tw-mt-[30px] tw-mb-[30px] sm:tw-mb-[65px]">
            <div className="tw-text-[25px] sm:tw-text-[32px] tk-trade-gothic-next-condensed tw-font-bold tw-mb-[10px] tw-pl-[4px]">Similar Products</div>
            <div id="similar-products" className="carousel slide" data-ride="carousel" data-interval="false">
                <div className="carousel-inner hidden-scrollbar tw-flex tw-gap-[14px] tw-overflow-auto">{carouselItems}</div>
                {productModel.SimilarItemsList.length > productsPerPage && <>
                    {window.innerWidth >= 576 &&
                        <a className="carousel-control-prev tw-bottom-auto tw-w-auto tw-left-[-14px] md:tw-left-[-20px] tw-opacity-100" href="#similar-products" role="button" data-slide="prev" onClick={prevClick}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" className="tw-group tw-w-[35px] xl:tw-w-auto">
                                <g id="Group_345" data-name="Group 345" transform="translate(-140 -2766)">
                                    <circle id="Ellipse_32" data-name="Ellipse 32" cx="21.5" cy="21.5" r="21.5" transform="translate(140 2766)" fill="#dfdfdf" className="group-hover:tw-fill-tamarillo-700" />
                                    <g id="arrow" transform="translate(186.928 2813.463) rotate(180)">
                                        <g id="Layer_1" transform="translate(19.2 11.5)">
                                            <path id="Path_445" data-name="Path 445" d="M22.444,40.463,36.425,26.482,22.444,12.5,19.2,15.772l10.71,10.71L19.2,37.191Z" transform="translate(-19.2 -12.5)" fill="#fff" />
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            <span className="sr-only">Previous</span>
                        </a>}
                    {window.innerWidth >= 576 &&
                        <a className="carousel-control-next tw-bottom-auto tw-w-auto tw-right-[-14px] md:tw-right-[-20px] tw-opacity-100" href="#similar-products" role="button" data-slide="next" onClick={nextClick}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" className="tw-group tw-w-[35px] xl:tw-w-auto">
                                <g id="Group_344" data-name="Group 344" transform="translate(-1781 -2765)">
                                    <circle id="Ellipse_32" data-name="Ellipse 32" cx="21.5" cy="21.5" r="21.5" transform="translate(1781 2765)" fill="#DFDFDF" className="group-hover:tw-fill-tamarillo-700" />
                                    <g id="arrow" transform="translate(1776.303 2760.5)">
                                        <g id="Layer_1" transform="translate(19.2 12.5)">
                                            <path id="Path_445" data-name="Path 445" d="M22.444,40.463,36.425,26.482,22.444,12.5,19.2,15.772l10.71,10.71L19.2,37.191Z" transform="translate(-19.2 -12.5)" fill="#fff" />
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            <span className="sr-only">Next</span>
                        </a>}
                </>}
            </div>
        </div>
    );

    function prevClick() {
        sliderPage.current--;
        $("#similar-products .carousel-control-next").show();
        if (sliderPage.current === 0) $("#similar-products .carousel-control-prev").hide();
        else $("#similar-products .carousel-control-prev").show();
    }

    function nextClick() {
        sliderPage.current++;
        $("#similar-products .carousel-control-prev").show();
        if (sliderPage.current >= Math.floor((productModel.SimilarItemsList.length - 1) / productsPerPage)) $("#similar-products .carousel-control-next").hide();
        else $("#similar-products .carousel-control-next").show();
    }
}